export default __webpack_public_path__ + "static/media/a-smiling-person-wearing-an-orange-t-shirt-and-a-n-9M5R2VS.300a9fed.jpg";